import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "./components/NetworkGraph";
import Reveal from "./components/Reveal";
import { IconGear, IconWrench, IconBox, IconCoin } from "./components/Icons";

const CATEGORIES = [
  {
    Icon: IconGear,
    title: "Geral",
    faqs: [
      {
        question: "O que é um MSP e por que contratar um?",
        answer:
          "MSP (Managed Service Provider) é um provedor de serviços gerenciados de TI. Em vez de chamar suporte só quando algo quebra, você contrata a sepolTECH para monitorar, prevenir e resolver problemas de forma proativa, por uma mensalidade fixa. Isso reduz downtime, custos surpresa e preocupações com tecnologia.",
      },
      {
        question: "A sepolTECH atende empresas de que porte?",
        answer:
          "Trabalhamos principalmente com pequenas e médias empresas em São Paulo. Nossa estrutura foi pensada para oferecer o mesmo nível de cuidado em TI que grandes corporações têm, mas em formato acessível para PMEs que não têm departamento de TI interno.",
      },
      {
        question: "Onde a sepolTECH atua?",
        answer:
          "Nosso atendimento presencial é em São Paulo, SP. O suporte remoto, monitoramento e gerenciamento de produtos em nuvem atende empresas em qualquer localidade com internet.",
      },
      {
        question: "Desde quando a sepolTECH está no mercado?",
        answer:
          "A sepolTECH foi fundada em 2007, em São Paulo. Ao longo de mais de 17 anos evoluímos de empresa de suporte e manutenção para um MSP completo, com portfólio próprio de produtos em nuvem.",
      },
    ],
  },
  {
    Icon: IconWrench,
    title: "Serviços",
    faqs: [
      {
        question: "Qual a diferença entre serviço e produto na sepolTECH?",
        answer:
          "Serviços são o que a sepolTECH faz por você — gestão de TI, suporte, consultoria, monitoramento de endpoints. Produtos são plataformas e softwares que a sepolTECH entrega para você usar, como hospedagem (sepolHOSTING), nuvem privada (sepolDRIVE), backup (sepolBACKUP), entre outros.",
      },
      {
        question: "Como funciona o contrato de Gestão de TI?",
        answer:
          "O contrato de Gestão de TI (MSP) é mensal e contempla monitoramento proativo da sua infraestrutura, suporte ilimitado para chamados, gestão de atualizações e patches, além de relatórios periódicos. O valor é fixo — sem cobranças extras por chamado.",
      },
      {
        question: "A sepolTECH faz atendimento presencial?",
        answer:
          "Sim. Fazemos atendimento presencial em São Paulo quando necessário. A maioria dos chamados é resolvida remotamente com agilidade, mas para situações que requerem presença física, nossa equipe vai até você.",
      },
      {
        question: "O que é RMM e como funciona na prática?",
        answer:
          "RMM (Remote Monitoring and Management) é a tecnologia que usamos para monitorar e gerenciar todos os dispositivos da sua empresa remotamente. Instalamos um agente leve nos computadores e servidores, que nos envia alertas em tempo real sobre saúde, performance, atualizações e possíveis problemas — antes que afetem sua operação.",
      },
    ],
  },
  {
    Icon: IconBox,
    title: "Produtos",
    faqs: [
      {
        question: "O que inclui o sepolHOSTING?",
        answer:
          "O sepolHOSTING oferece hospedagem de sites, e-mail corporativo e VPS (servidores virtuais privados) em nuvem. Toda a infraestrutura é gerenciada e suportada pela sepolTECH, com uptime garantido e suporte técnico incluído.",
      },
      {
        question: "O sepolDRIVE é diferente do Google Drive ou OneDrive?",
        answer:
          "Sim, e muito. O sepolDRIVE usa Nextcloud em nuvem privada — seus dados ficam em um servidor dedicado à sua empresa, sem passar por servidores do Google ou Microsoft. Você tem controle total sobre quem acessa, onde os dados ficam e como são usados. É a escolha de quem leva privacidade e conformidade a sério.",
      },
      {
        question: "O sepolBACKUP precisa de intervenção manual?",
        answer:
          "Não. O sepolBACKUP é um serviço gerenciado — configuramos, monitoramos e validamos seus backups automaticamente. Você não precisa lembrar de fazer backup: a sepolTECH cuida de tudo e você recebe relatórios periódicos confirmando que seus dados estão protegidos.",
      },
      {
        question: "O sepolSECURITY é só um antivírus?",
        answer:
          "Não. O sepolSECURITY usa o Bitdefender GravityZone, uma plataforma corporativa com EPP (Endpoint Protection Platform) e EDR (Endpoint Detection and Response) integrado. Vai muito além do antivírus: detecta comportamentos suspeitos, responde a ameaças avançadas, bloqueia ataques de ransomware e fornece visibilidade completa do ambiente de segurança da sua empresa — tudo gerenciado pela sepolTECH.",
      },
      {
        question: "Posso contratar só um produto sem os serviços?",
        answer:
          "Sim. Nossos produtos (sepolHOSTING, sepolDRIVE, sepolBACKUP, sepolCHAT, sepolSECURITY, ERP Bruning) podem ser contratados de forma independente. No entanto, quando combinados com nossos serviços de gestão, a eficiência é muito maior — e o suporte já está incluso.",
      },
    ],
  },
  {
    Icon: IconCoin,
    title: "Financeiro & Contratos",
    faqs: [
      {
        question: "Como é feita a cobrança dos serviços?",
        answer:
          "Nossos serviços e produtos são cobrados mensalmente, com valor fixo definido em contrato. Não há cobranças surpresa por chamado ou uso — você sabe exatamente o que paga todo mês.",
      },
      {
        question: "Qual o prazo mínimo de contrato?",
        answer:
          "Os prazos e condições são definidos na proposta comercial de acordo com o serviço contratado. Entre em contato com nossa equipe para receber uma proposta personalizada.",
      },
      {
        question: "Como solicito uma proposta?",
        answer:
          'É simples: clique em "Fale Conosco" em qualquer página do site, preencha o formulário de contato ou nos envie um e-mail para contato@sepoltech.com.br. Nossa equipe entra em contato em até 1 dia útil para agendar uma conversa e entender sua necessidade.',
      },
    ],
  },
];

export default function Faq() {
  // Como o accordion é único para a página inteira (não por categoria),
  // guardamos a chave como "categoriaIndex-faqIndex" em vez de um número simples.
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (key) => {
    setOpenFaq((prev) => (prev === key ? null : key));
  };

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container" style={{ textAlign: "center" }}>
          <div className="breadcrumb animate-up" style={{ justifyContent: "center" }}>
            <Link to="/">Início</Link>
            <span>/</span>
            <span>FAQ</span>
          </div>
          <div className="tag animate-up animate-up--d1">Perguntas Frequentes</div>
          <h1
            className="section-title animate-up animate-up--d2"
            style={{ fontSize: "clamp(32px,5vw,52px)" }}
          >
            Tudo que você quer saber
            <br />
            <span className="text-blue">sobre a sepolTECH</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "17px",
              color: "var(--text-secondary)",
              maxWidth: "560px",
              margin: "16px auto 0",
              lineHeight: "1.7",
            }}
          >
            Respondemos as dúvidas mais comuns sobre nossos serviços,
            produtos e forma de trabalho. Não encontrou o que procura? Fale
            com a gente.
          </p>
        </div>
      </section>

      {/* ═══════════════ CATEGORIAS DE FAQ ═══════════════ */}
      <section className="section">
        <div className="container" style={{ maxWidth: "800px" }}>
          {CATEGORIES.map((category, categoryIndex) => (
            <div style={{ marginBottom: "56px" }} key={category.title}>
              <Reveal
                as="h2"
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "var(--brand-blue)",
                  marginBottom: "24px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <category.Icon style={{ width: "20px", height: "20px" }} />
                {category.title}
              </Reveal>

              {category.faqs.map((faq, faqIndex) => {
                const key = `${categoryIndex}-${faqIndex}`;
                return (
                  <Reveal
                    className={`faq-item${openFaq === key ? " open" : ""}`}
                    delay={faqIndex * 0.04}
                    key={faq.question}
                  >
                    <button
                      className="faq-btn"
                      onClick={() => toggleFaq(key)}
                      aria-expanded={openFaq === key}
                    >
                      {faq.question}
                      <span className="faq-btn__icon">+</span>
                    </button>
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          ))}

          {/* Não encontrou */}
          <Reveal className="cta-banner" style={{ marginTop: "48px" }}>
            <h2 className="cta-banner__title" style={{ fontSize: "28px" }}>
              Não encontrou sua dúvida?
            </h2>
            <p className="cta-banner__sub">
              Nossa equipe está pronta para responder qualquer pergunta
              sobre serviços, produtos ou contratos.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Falar com a equipe →
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
